class CompareService {

    compareById(a: any, b: any) {
        if (b.id < a.id) {
            return -1;
        }
        return 0;
    }

    compareByDescription(a: any, b: any) {
        if (a.description < b.description) {
            return -1;
        }
        return 0;
    }
}

export default new CompareService();
